<template>
  <el-form ref="form" :model="formData" size="mini">
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="结果推送状态">
          <el-input v-model="formData.v_resultPushStatus" readonly> </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="结果推送时间">
          <el-input
            v-model="formData.resultPushTime"
            readonly
            prefix-icon="el-icon-date"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="结果推送数据">
          <el-input
            v-model="formData.resultPushData"
            type="textarea"
            rows="5"
            readonly
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="结果推送响应时间">
          <el-input
            v-model="formData.resultPushReplyTime"
            readonly
            prefix-icon="el-icon-date"
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="10">
      <el-col :span="24">
        <el-form-item label="结果推送响应数据">
          <el-input
            v-model="formData.resultPushReplyData"
            type="textarea"
            rows="5"
            readonly
          >
          </el-input>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>
<script>
export default {
  props: {
    formData: { type: Object, default: () => {} },
  },
}
</script>
